import { FormControl } from '@angular/forms';
import { CurrencyType } from '../../enum/constants';

export interface PriceForm {
  budget: FormControl<boolean | null>;
  value: FormControl<number | null>;
  currency: FormControl<CurrencyType | null>;
  trade: FormControl<boolean | null>;
  negotiable: FormControl<boolean | null>;
}

export interface OlxPricePayload {
  budget: boolean | null;
  value: number | null;
  currency: CurrencyType | null;
  trade: boolean | null;
  negotiable: boolean | null;
}

export enum OlxPriceType {
  EXCHANGE = 'exchange',
  FREE = 'free',
  PRICE = 'price',
}

export interface OlxPriceTypeDropdownItem {
  name: string;
  value: OlxPriceType;
}

export const OLX_PRICE_TYPES: OlxPriceTypeDropdownItem[] = [
  { name: 'price', value: OlxPriceType.PRICE },
  { name: 'free', value: OlxPriceType.FREE },
  { name: 'trade', value: OlxPriceType.EXCHANGE },
];

export const AVAILABLE_PRICE_TYPES = [
  OlxPriceType.PRICE,
  OlxPriceType.FREE,
  OlxPriceType.EXCHANGE,
];
